import { FormEvent, useEffect, useRef, useState } from "react";
import { X } from "lucide-react";
import { useDialog } from "./useDialog";

interface RoomNameDialogProps {
  title: string;
  initialValue?: string;
  onCancel: () => void;
  onSubmit: (name: string) => void | Promise<void>;
}

export function RoomNameDialog({
  title,
  initialValue = "",
  onCancel,
  onSubmit
}: RoomNameDialogProps): JSX.Element {
  const [name, setName] = useState(initialValue);
  const inputRef = useRef<HTMLInputElement>(null);
  const dialogRef = useDialog<HTMLFormElement>(true, onCancel);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const clean = name.trim();
    if (!clean) {
      return;
    }
    await onSubmit(clean);
  }

  return (
    <div className="dialog-backdrop" role="presentation">
      <form ref={dialogRef} className="dialog" role="dialog" aria-modal="true" aria-labelledby="room-name-title" onSubmit={handleSubmit}>
        <div className="dialog__body">
          <div className="topbar">
            <h2 id="room-name-title">{title}</h2>
            <button className="icon-button" type="button" aria-label="Close" onClick={onCancel}>
              <X size={18} aria-hidden="true" />
            </button>
          </div>
          <div className="field">
            <label htmlFor="room-name">Room name</label>
            <input
              ref={inputRef}
              id="room-name"
              className="input"
              value={name}
              maxLength={80}
              onChange={(event) => setName(event.target.value)}
            />
          </div>
          <div className="button-row">
            <button className="button button--primary" type="submit">
              Save
            </button>
            <button className="button" type="button" onClick={onCancel}>
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
